import React, { FunctionComponent, useCallback } from "react";
import styles from "./Header2.module.scss";
import Header2Props from "./Header2Props.interface";

import MenuOverlay from "./components/MenuOverlay/MenuOverlay"
import Navigation from "./components/Navigation/Navigation";
import setHeaderStyles from "./hooks/setHeaderStyles";
import SocialLinks from "./components/SocialLinks/SocialLinks";

import { CLOSE_ALL_OVERLAYS, OPEN_MENU } from "layout/redux/overlay.actions";
import { useDispatch, useSelector } from "react-redux";
import Button from "components/Button/Button";
import combineClasses from "helpers/combine-classes";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useScrollState from "layout/Header/hooks/useScrollState";
import Anchor from "components/Anchor/Anchor";
import FixrOverlay from "./components/FixrOverlay/FixrOverlay";

const Header2: FunctionComponent<Header2Props> = (props) => {
    const dispatch = useDispatch();

    let header: any;
    if (props?.theme?.header && props?.theme?.header.length > 0) {
        header = props?.theme?.header?.[0]?.content;
    }

    const headerStyles = setHeaderStyles(header);
    const scrollTypeClass = useScrollState(header?.scrollType, styles);

    const page = useSelector(state => state.page.content);

    const overlay = useSelector(state => state.overlay);
    const overlayActiveClass = overlay.currentOverlay === "MENU" ? styles.is_active : undefined;

    const logoTypeClass = header?.logoType ? styles[`logo_type_${header.logoType}`] : undefined;
    const logoImageType = header?.logoType === "Vertical" ? "containX" : "containY";
    const imageAspectRatio = getImageAspectRatio(undefined, header?.logo?.umbracoWidth, header?.logo?.umbracoHeight);

    const hasTwoHeaderButtonsClass = props.headerButtons && props.headerButtons?.length > 1 ? styles.two_header_buttons : "";
    const headerButtonContentType = header?.headerButtons?.[0] && header.headerButtons.length > 0 ? header.headerButtons[0].content._contentType : undefined;

    const toggleMenu = useCallback((event: any) => {
        if (event) {
            event.stopPropagation();
        }

        if (overlay?.currentOverlay === "MENU") {
            dispatch({
                type: CLOSE_ALL_OVERLAYS
            });
        }
        else {
            dispatch({
                type: OPEN_MENU
            });
        }
    }, [overlay.currentOverlay]);

    return (
        <header className={combineClasses(styles.wrapper, scrollTypeClass)} style={headerStyles}>
            <div className={combineClasses(styles.inner, logoTypeClass)}>
                {header?.logo ? (
                    <Anchor className={styles.image_link} to={page?._homeNodeUrl}>
                        <ImageViewer className={styles.image} src={header.logo.umbracoFile.src} extensionType="png" type={logoImageType} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    </Anchor>
                ) : null}

                <div className={styles.content}>
                    
                    <Navigation menu={props.menu} />

                    <SocialLinks {...props} />

                    {/* Buttons */}
                    {props.headerButtons ? (
                        <div className={combineClasses(styles.action_buttons, hasTwoHeaderButtonsClass)}>
                            {props.headerButtons?.map((button, index) => {
                                return (
                                    <Button key={index} to={button.content.link} className={styles.action_button} contentType={headerButtonContentType} {...button.content}>
                                        {button.content.label}
                                    </Button>
                                );
                            })}
                        </div>
                    ) : null}
                </div>

                <button className={combineClasses(styles.menu_toggle_button, overlayActiveClass)} onClick={(event) => toggleMenu(event)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            {overlay.currentOverlay === "MENU" ? (
                <MenuOverlay header={header} page={page} {...props} />
            ) : null}
        
            {overlay.currentOverlay === "FIXR_OVERLAY" ? (
                <FixrOverlay {...props} state={overlay.currentOverlay} />
            ) : null}
        </header>
    );
};

export default Header2;